<script setup lang="ts">
import LogoIcon from '@/assets/images/logo-notice.svg?component';

const NEW_PLATFORM_URL = 'https://platform.oversecured.com/';
</script>

<template>
  <div
    class="new-platform-notice tw:flex tw:flex-col tw:items-center tw:text-center tw:gap-5 tw:w-full tw:max-w-90 tw:px-8 tw:py-10 tw:rounded-2xl tw:border tw:border-pr-grey200 tw:bg-white tw:font-aspekta"
  >
    <span
      class="tw:flex tw:items-center tw:justify-center tw:w-14 tw:h-14 tw:rounded-full tw:bg-blue-bg"
    >
      <LogoIcon class="tw:max-w-6" />
    </span>
    <h2 class="tw:m-0 tw:typography-h2 tw:text-main">Sign up on our new platform</h2>
    <p class="tw:m-0 tw:typography-small tw:text-secondary">
      Account creation now happens on our new platform — head over to get started.
    </p>
    <a
      :href="NEW_PLATFORM_URL"
      class="tw:inline-flex tw:items-center tw:justify-center tw:w-full tw:px-6 tw:py-3 tw:rounded-lg tw:bg-brand-primary tw:text-white tw:font-semibold tw:no-underline tw:transition-opacity hover:tw:opacity-90"
    >
      Go to the new platform
    </a>
  </div>
</template>
